__turbopack_context__.v({
  "facet": "site-search-module-scss-module__1MzqQq__facet",
  "facets": "site-search-module-scss-module__1MzqQq__facets",
  "facetsWrapper": "site-search-module-scss-module__1MzqQq__facetsWrapper",
  "generalSearch": "site-search-module-scss-module__1MzqQq__generalSearch",
  "noResults": "site-search-module-scss-module__1MzqQq__noResults",
  "notification": "site-search-module-scss-module__1MzqQq__notification",
  "pagination": "site-search-module-scss-module__1MzqQq__pagination",
  "results": "site-search-module-scss-module__1MzqQq__results",
  "search": "site-search-module-scss-module__1MzqQq__search",
  "sectionTitle": "site-search-module-scss-module__1MzqQq__sectionTitle",
  "subTitle": "site-search-module-scss-module__1MzqQq__subTitle",
  "title": "site-search-module-scss-module__1MzqQq__title",
});
